(function ($) {
  function initCountdown() {
    var $root = $(this);
    if ($root.data("countdown-ready")) return;
    var end = Date.parse($root.attr("data-countdown-end") || "");
    if (isNaN(end)) return;
    $root.data("countdown-ready", true);
    function render() {
      var remaining = Math.max(0, end - Date.now()),
        days = Math.floor(remaining / 864e5),
        hours = Math.floor((remaining % 864e5) / 36e5),
        minutes = Math.floor((remaining % 36e5) / 6e4),
        seconds = Math.floor((remaining % 6e4) / 1e3);
      $root.find("[data-countdown-days]").text(String(days).padStart(2, "0"));
      $root.find("[data-countdown-hours]").text(String(hours).padStart(2, "0"));
      $root
        .find("[data-countdown-minutes]")
        .text(String(minutes).padStart(2, "0"));
      $root
        .find("[data-countdown-seconds]")
        .text(String(seconds).padStart(2, "0"));
      if (!remaining) {
        clearInterval($root.data("countdown-timer"));
        $root.removeData("countdown-timer");
      }
    }
    render();
    $root.data("countdown-timer", setInterval(render, 1e3));
  }
  function init(scope) {
    $(scope)
      .find("[data-form-countdown]")
      .addBack("[data-form-countdown]")
      .each(initCountdown);
  }
  $(function () {
    init(document);
  });
  $(document).on("shopify:section:load", function (event) {
    init(event.target);
  });
})(jQuery);
/* Reusable FAQ accordion start */
(function ($) {
  if (!$) return;
  $(document).on('click', '.faqGrid__summary', function () {
    var $button = $(this);
    var $item = $button.closest('.faqGrid__item');
    var $answer = $item.find('.faqGrid__answer').first();
    var isOpen = $item.hasClass('is-open');
    $item.toggleClass('is-open', !isOpen);
    $button.attr('aria-expanded', String(!isOpen));

    $answer.stop(true, true);
    if (isOpen) {
      $answer.slideUp(250, function () {
        $answer.prop('hidden', true);
      });
    } else {
      $answer.prop('hidden', false).hide().slideDown(250);
    }
  });
})(window.jQuery);
/* Reusable FAQ accordion end */
